import axios from 'axios';
import { servicePath } from '../../constants/defaultValues';
const { observable, runInAction } = require('mobx');

const globalStore = observable({
    appTitle:'양방향 무선 점멸기 통합 관제',
    controlMode: '',
    restMode: '',
    nightMode: '',
    failMode: '',
    controlTitle: '',
    deviceTitle: '',
    userCode: '',

    iotCount: 0,
    lteCount: 0,
    iotBoanCount : 0,
    iotGaroCount: 0,
    
    iotNight: 0,
    iotRest: 0,
    iotDaylight: 0,

    garoOn: 0,
    garoOff: 0,
    garoONOff: 0,
    garoNight:0,

    lightOn: 0,
    lightDayLight: 0,
    lightForceOn: 0,
    lightOff: 0,

    failLamp: 0,
    failRegular: 0,
    failPower: 0,
    failNet: 0,
    dataCount: -1,
    data: [],

    pageGubun: 0, // 메인에서 클릭시 조회 조건.
    pageValue: 0,
});


const codeStore = observable({
  isLoaded: false,
  userCode: 0,
  makerOptions: [],
  //ctrlOptions: [],
  instOptions: [],
  modelOptions: [],
  lampTypeOptions: [],
  lampCapaOptions: [],
  loadCode(userCode) {
    var apiUrl = `${servicePath}/device_v03.php?cmd=codelist`;
    apiUrl = `${apiUrl}&userId=${userCode}`
    //console.log(apiUrl);
    this.userCode = userCode;
    axios
      .get( apiUrl)
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        //console.log('코드 불러오기')
        this.isLoaded = true;
        this.codes = data['data'];
        this.makerOptions = [];
        //this.ctrlOptions = [];
        this.modelOptions = [];
        this.instOptions = [];
        this.lampTypeOptions = [];
        this.lampCapaOptions = [];
        
        //console.log(data)
        data['data'].forEach(item => {
          if (item.userId==userCode) {
            item.isSelected = true;
            if (item.gubun==1) {
              this.makerOptions.push(item)
            // } else if (item.gubun==2) {
            //   this.ctrlOptions.push(item)
            } else if (item.gubun==3) {
              this.modelOptions.push(item)
            } else if (item.gubun==4) {
              this.instOptions.push(item)
            } else if (item.gubun==5) {
              this.lampTypeOptions.push(item)
            } else if (item.gubun==6) {
              this.lampCapaOptions.push(item)
            }
          }
          //console.log(item)
        });

        this.sortCodes();

      });
  },
  sortArrayByCode(arr) {
    arr.sort(function (a,b) {
      const a1 = parseInt(a.code);
      const a2 = parseInt(b.code);
      if (a1 > a2) return 1
      else if (a1 < a2) return -1
      else return 0;
    });
  },
  sortCodes() {
    this.sortArrayByCode(this.makerOptions);
    //this.sortArrayByCode(this.ctrlOptions);
    this.sortArrayByCode(this.modelOptions);
    this.sortArrayByCode(this.instOptions);
    this.sortArrayByCode(this.lampTypeOptions);
    this.sortArrayByCode(this.lampCapaOptions);
//    console.log('메이커',this.makerOptions.length)
  },
  deleteItem(arr, item) {
    for(var i=0; i<arr.length; i++) {
      if (arr[i].id == item.id) {
        arr.splice(i, 1);
        break;
      }
    }
  },
  deleteCode(item) {
    item.isSelected = true;
    if (item.gubun==1) {
      this.deleteItem(this.makerOptions, item);
    } else if (item.gubun==2) {
      this.deleteItem(this.ctrlOptions, item);
    } else if (item.gubun==3) {
      this.deleteItem(this.modelOptions, item);
    } else if (item.gubun==4) {
      this.deleteItem(this.instOptions, item);
    } else if (item.gubun==5) {
      this.deleteItem(this.lampTypeOptions, item);
    } else if (item.gubun==6) {
      this.deleteItem(this.lampCapaOptions, item);
    }
  },
  getMakerCode(aUserCode,idValue) {
    //console.log('메이커 get',aUserCode, idValue)
    if (idValue==null) return '-';
    var ret = this.makerOptions.find((x) => x.code == idValue)
    if (ret!=null) return ret.name
    else this.getDataCode(aUserCode,1, idValue);
  },

  // getCtrl(aUserCode,idValue) {
  //   if (idValue==null) return '-';
  //   var ret = this.ctrlOptions.find((x) => x.code == idValue)
  //   if (ret!=null) return ret.name
  //   else this.getDataCode(aUserCode,2, idValue);
  // },

  getModel(aUserCode,idValue) {
    if ( (idValue==null) || (idValue==0)) return ' - ';
    var ret = this.modelOptions.find((x) => x.code == idValue)
    if (ret!=null) return ret.name
    else return this.getDataCode(aUserCode,3, idValue);
  },
  getInst(aUserCode,idValue) {
    if ( (idValue==null) || (idValue==0)) return ' - ';
    var ret = this.instOptions.find((x) => x.code == idValue)
    if (ret!=null) return ret.name
    else return this.getDataCode(aUserCode,4, idValue);
  },
  getLampType(aUserCode,idValue) {
    if ( (idValue==null) || (idValue==0)) return ' - ';
    var ret = this.lampTypeOptions.find((x) => x.code == idValue)
    if (ret!=null) return ret.name
    else return  this.getDataCode(aUserCode,5, idValue);
  },
  getLampCapa(aUserCode,idValue) {
    if ( (idValue==null) || (idValue==0)) return ' - ';
    var ret = this.lampCapaOptions.find((x) => x.code == idValue)
    if (ret!=null) return ret.name
    else return this.getDataCode(aUserCode,6, idValue);
  },
  getDataCode(aUserCode, iGubun, iCode) {
    if ( (iCode==null) || (iCode==0)) return ' - ';
    var iLen = this.codes.length
    for (var i=0; i<iLen; i++) {
      const item = this.codes[i];
      if (item.userCode == aUserCode) {
        if (item.gubun == iGubun) {
          if (item.code == iCode) {
            console.log('item', item);
            return item.name;
          }
        }
      }
    }
    return '  -  ';
  },

});


  const userOptions = [
    { id: '0', label: '-' },
    { id: '1', label: '신성일렉콤' },
//    { id: '2', label: '동선기업' },
    { id: '200', label: '광주시청' },
    { id: '220', label: '남양주시청' },
    { id: '225', label: '여주시청' },
    { id: '112', label: '강동구청' },
    { id: '201', label: '분당구청' },
    { id: '204', label: '수정구청' },
    { id: '203', label: '중원구청' },
    { id: '311', label: '고흥군청' },
    { id: '111', label: '호평동 문화체육팀' },
//    { id: '200', label: '성남시청' },
    // { id: '312', label: '완산구' },
    // { id: '313', label: '덕진구' },
  ];
  

  const codeGubunList = [
    { id: '1', label: '제조사' },
    //{ id: '2', label: '제어기종류' },
    { id: '3', label: '모델명' },
    { id: '4', label: '설치형태' },
    { id: '5', label: '램프종류' },
    { id: '6', label: '램프용량' },
    // { id: '7', label: '장애유형' },
    // { id: '8', label: '장애처리유형' },
    // { id: '9', label: '삭제유형' },
  ];
  

  function ConvUserCode(item)
  {
    if (item==null) return '-';
    var ret =  userOptions.find((x) => x.id == item)
    if (ret==null) return '-';
    return ret.label;
  }

  function Unix_timestamp(t)
  {
    var dt = new Date(t*1000);
    var year = dt.getFullYear();
    var mon = dt.getMonth()+1;
    var day = dt.getDate();
    var hour = dt.getHours()
    // var hr = dt.getHours();
    // var m = "0" + dt.getMinutes();
    // var s = "0" + dt.getSeconds();

    if (year<2000) {
      return "-"
    } else {
      return year+'.'+mon+'.'+day+' '+hour+'H';
    }
  }
  
  function Unix_timestampDays(t)
  {
    var dt = new Date(t*1000);    
    var hour = dt.getHours();
    var min = dt.getMinutes();
    var days = Math.trunc( t / 60 / 60 / 24);
    // var hr = dt.getHours();
    // var m = "0" + dt.getMinutes();
    // var s = "0" + dt.getSeconds();
    if (days>5000) {
      return "-"
    } else return days+'d '+hour+':'+min;
  }
  
  
  
  function FetchSummary() {

    var apiUrl = `${servicePath}/device_v04.php?cmd=listsum`;
    if (globalStore.userCode>2) {
      apiUrl = `${apiUrl}&user=${globalStore.userCode}`
    } else {
      apiUrl = `${apiUrl}&user=0`
    }

    // apiUrl = `${apiUrl}`
    axios
      .get(apiUrl )
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        //console.log(data);
        if (data) {

          runInAction(() => {
            globalStore.iotCount = 0;
            globalStore.lteCount = 0;
            globalStore.iotBoanCount  = 0;
            globalStore.iotGaroCount = 0;
            
            globalStore.iotNight = 0;
            globalStore.iotRest = 0;
            globalStore.iotDaylight = 0;
        
            globalStore.garoOn = 0;
            globalStore.garoOff = 0;
            globalStore.garoONOff = 0;
            globalStore.garoNight =0;

            globalStore.lightOn = 0;
            globalStore.lightCdsOn = 0;
            globalStore.lightForceOn = 0;
            globalStore.lightOff = 0;
        
            globalStore.failPower = 0;
            globalStore.failNet = 0;
            globalStore.failLamp = 0;
            globalStore.failRegular = 0;
            globalStore.dataCount = 0;

            var i;
            var unixTime = Math.floor(new Date().getTime() / 1000);
            for (i=0; i<data.data.length; i++ ) {
              if (Number(data.data[i].modemId)>0) {
                //console.log('관제o', data.data[i]);
                if ( data.data[i].opType === '3') {
                  if (data.data[i].ctrlType === '1') globalStore.iotCount++;
                  if (data.data[i].ctrlType === '2') globalStore.lteCount++;
                  if (data.data[i].ctrlType === '3') globalStore.iotBoanCount++;
                  if (data.data[i].ctrlType === '4') globalStore.iotBoanCount++;
                  if (data.data[i].ctrlType === '5') globalStore.iotGaroCount++;
                  if (data.data[i].ctrlType === '6') globalStore.iotGaroCount++;
                  if ((data.data[i].nightType === 'B') || (data.data[i].nightType === 'C')) globalStore.iotNight++;
                  if ((data.data[i].restType === 'B') || (data.data[i].restType === 'C')) globalStore.iotRest++;
                  if (data.data[i].useCds === '1')  globalStore.iotDaylight++;
                  if (data.data[i].deviceSn === null) {
                    data.data[i].deviceSn = "";
                  }
    
                  var timeDiff = (unixTime-data.data[i].lastUpdate);
    
                  if ((data.data[i].ctrlType === '1') || (data.data[i].ctrlType === '2')) {
                    if (data.data[i].pwFail === '1') 
                    {
                      data.data[i].state = '1';
                      globalStore.failPower++
                    } else {
                      //if (timeDiff<(240*60) ) {
                        if (data.data[i].state === '0') {
                          if (data.data[i].onOff === '0') globalStore.lightOff++;
                          if (data.data[i].onOff === '1') globalStore.lightOn++;
                          if (data.data[i].onOff === '2') globalStore.lightForceOn++;
                          if (data.data[i].onOff === '3') globalStore.lightCdsOn++;
                        } else if (data.data[i].state === '2') {
                          globalStore.failNet++
                        } else if (data.data[i].state === '1') {
                          if (data.data[i].eventCode === '1') globalStore.failRegular++
                          else if (data.data[i].eventCode === '2') globalStore.failLamp++
                          else globalStore.failPower++
                        } else {
                          data.data[i].state = '2';
                          globalStore.failNet++;
                        }
                      //} else {
                        // 최종 통신시간이 4시간 이상이면 통신이상
                      // }
                    }
                  }
                }
                //console.log(data.data[i].id, data.data[i].state,  data.data[i].onOff, Unix_timestamp(data.data[i].lastUpdate), '('+Unix_timestampDays(timeDiff)+')');
              } else { 
                // Modem ID 가 없을때...
                //console.log('관제x', data.data[i]);
                if ((data.data[i].opType === '3')) {
                  if (data.data[i].ctrlType === '1') globalStore.iotCount++;
                  if (data.data[i].ctrlType === '2') globalStore.lteCount++;
                  if (data.data[i].ctrlType === '3') globalStore.iotBoanCount++;
                  if (data.data[i].ctrlType === '4') globalStore.iotBoanCount++;
                  if (data.data[i].ctrlType === '5') globalStore.iotGaroCount++;
                  if (data.data[i].ctrlType === '6') globalStore.iotGaroCount++;
                }
              }
            }
          });
          //console.log(data.data);
          globalStore.data = data.data;  
        };
        //globalStore.iotBoanCount
      });
  }

export { globalStore, codeStore, codeGubunList, userOptions, FetchSummary, ConvUserCode};
